module.exports = __webpack_public_path__ + "img/logo_fr.05341b32.jpg";